.container {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
